import React from 'react';
import { Line, Pie, Bar, Doughnut, Radar, PolarArea } from 'react-chartjs-2';
import FunctionalityChartComponent from './../Functionality/ChartComponent';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    RadarController,
    RadialLinearScale,
    PolarAreaController,
} from 'chart.js';
import { ChartType } from '../../../enums/chartType';

ChartJS.register(
    CategoryScale,
    ArcElement,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    RadarController,
    RadialLinearScale,
    Title,
    Tooltip,
    Legend,
    PolarAreaController,
    ArcElement,
);
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ChartComponent = ({ data, label, typo, onRemove }) => {
    const { updatedData, options } = FunctionalityChartComponent({ data, label, typo, onRemove });

    return (
        <div className='chart-container'>
            {typo === ChartType.LINE && <Line data={updatedData} options={options} />}
            {typo === ChartType.BAR && <Bar data={updatedData} options={options} />}
            {typo === ChartType.PIE && <Pie data={updatedData} options={options} />}
            {typo === ChartType.DOUGHNUT && <Doughnut data={updatedData} options={options} />}
            {typo === ChartType.RADAR && <Radar data={updatedData} options={options} />}
            {typo === ChartType.POLAR && <PolarArea data={updatedData} options={options} />}
        </div>
    );
};

export default ChartComponent;
